<!-- <div class="shadow-gray-500/20">
    <div class="flex justify-center text-center text-2xl font-bold p-3 mt-8">{{data.title}}</div>
    <form class="p-5" [formGroup]="form">
        <div class="flex flex-col lg:w-[600px] m-auto">
            <div class="flex lg:flex-row flex-col text-center">
                <mat-form-field color="accent" appearance="outline" class="m-1 lg:w-1/2">
                    <mat-label>Title </mat-label>
                    <input formControlName="title" matInput placeholder="Title">
                </mat-form-field>
                <mat-form-field color="accent" appearance="outline" class="m-1 lg:w-1/2">
                    <mat-label>Description</mat-label>
                    <input formControlName="description" matInput placeholder="Description">
                </mat-form-field>
            </div>
            <div class="flex flex-col font-bold ml-2">Typology
                <span class="font-bold text-lg">Sales</span>
            </div>
            <div class="flex flex-row text-center">
                <mat-form-field color="accent" appearance="outline" class="lg:w-full">
                    <mat-label>Select one or more outlet </mat-label>
                    <input formControlName="outlet" matInput placeholder="Select one or more outlet">
                </mat-form-field>
            </div>
            <div class="flex flex-row text-center">
                <mat-form-field color="accent" appearance="outline" class="m-1 lg:w-1/2">
                    <mat-label>Select a KPI</mat-label>
                    <input formControlName="kpi" matInput placeholder="Select a KPI">
                </mat-form-field>
                <mat-form-field color="accent" appearance="outline" class="m-1 lg:w-1/2">
                    <mat-label>KPI goal value</mat-label>
                    <input formControlName="kpiGoalValue" matInput placeholder="KPI goal value">
                </mat-form-field>
            </div>
            <div class="flex flex-row text-center">
                <mat-form-field color="accent" appearance="outline" class="m-1 lg:w-1/2">
                    <mat-label>Date start </mat-label>
                    <input formControlName="dateStart" matInput placeholder="Date start" [matDatepicker]="pickerStart">
                    <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStart></mat-datepicker>
                </mat-form-field>
                <mat-form-field color="accent" appearance="outline" class="m-1 lg:w-1/2">
                    <mat-label>Due date </mat-label>
                    <input formControlName="dueDate" matInput placeholder="Due date" [matDatepicker]="pickerDue">
                    <mat-datepicker-toggle matSuffix [for]="pickerDue"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDue></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="m-auto md:w-7/12 w-11/12 pt-5 justify-center flex flex-row">
                <button [disabled]="!form.valid" mat-raised-button [mat-dialog-close]="form" color="accent"
                    class="w-full">SAVE</button>
            </div>
        </div>
    </form>
</div> -->


<h2 mat-dialog-title class="my-5">{{('Insert a new Action Plan' | translate) | async}}</h2>
<mat-dialog-content>
    <app-dynamic-form *ngIf="formGroup && inputForm" [formGroup]="formGroup" [inputForm]="inputForm"
        [appearanceForm]="'outline'" class="mt-10">
    </app-dynamic-form>
</mat-dialog-content>
<mat-dialog-actions *ngIf="showButton">
    <div class="w-full">
        <div class="flex flex-row justify-center items-center mt-8">
            <button mat-flat-button color="accent" [disabled]="!formGroup.valid" (click)="onSave()"
                class="w-1/3">{{utils.traslatei18n('Save')}}</button>
        </div>
    </div>
</mat-dialog-actions>